// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"44":"AllFeaturedBrands","148":"Detail","594":"about"}[chunkId] || chunkId) + "." + {"44":"bd4ab52c","148":"7ce72157","376":"d3404d5f","514":"037dee82","594":"0139fd6d"}[chunkId] + ".js";
};